import React from "react";
import { Path } from "react-native-svg"
import { Icon } from "~/native-ui"

export default (props) => {
    return (
        <Icon { ...props } viewBox="0 0 100 120" enableBackground="new 0 0 100 100">
            <Path
                d="M93.443,69.035L79.057,47.982L65.197,69.035l9.18-2.092c-0.566,11.259-8.775,20.536-19.53,22.736V34.562h11.491V26.14  H54.847v-4.091c3.933-1.853,6.667-5.843,6.667-10.47C61.514,5.195,56.318,0,49.934,0c-6.385,0-11.579,5.195-11.579,11.579  c0,4.626,2.734,8.617,6.667,10.47v4.091H33.531v8.421h11.491V89.68c-10.74-2.197-18.94-11.451-19.527-22.688l9.308,2.043  L20.417,47.982L6.557,69.035l9.111-2.076C16.333,85.291,31.444,100,49.934,100c18.474,0,33.576-14.685,34.265-32.994L93.443,69.035z   M49.934,5.614c3.289,0,5.964,2.676,5.964,5.965c0,3.289-2.676,5.965-5.964,5.965c-3.289,0-5.965-2.676-5.965-5.965  C43.969,8.29,46.645,5.614,49.934,5.614z"
            />
        </Icon>
    )
}